import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Fragment, memo, useReducer, useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Modal, Text, Checkbox } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import MatchingList from "./MatchingList";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'MatchingModal');
const initialState = {
  data: null,
  fields: null,
  fieldSchema: null,
  isOpen: false,
  canCreate: false,
  nodeSetData: null,
  refreshCells: null,
  hideMatchedFlields: false
};
function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        data: action.data,
        fieldSchema: action.fieldSchema,
        fields: action.fields,
        isOpen: true,
        canCreate: action.canCreate,
        matchFieldsNode: action.matchFieldsNode,
        matchFieldsApi: action.matchFieldsApi
      };
    case 'match':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            extraInfo: _objectSpread(_objectSpread({}, state.data.extraInfo), {}, {
              [action.field]: action.value
            })
          })
        });
      }
    case 'close':
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpen: false
      });
    case 'toggleHideMatchedFlields':
      return _objectSpread(_objectSpread({}, state), {}, {
        hideMatchedFlields: !state.hideMatchedFlields
      });
    default:
      throw new Error('No action provided');
  }
}
const MatchingModal = _ref => {
  var _state$fieldSchema;
  let {
    onConfirm,
    onRef,
    matchBy
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const [state, dispatch] = useReducer(reducer, initialState);

  // Modal handlers
  const onConfirmModal = useCallback(() => {
    state.matchFieldsNode.setData(state.data);
    state.matchFieldsApi.refreshCells({
      columns: ['nameField', 'extraInfo'],
      force: true
    });
    onConfirm && onConfirm(state.data);
    dispatch({
      type: 'close'
    });
  }, [state, onConfirm]);
  const handleOnClose = useCallback(() => {
    dispatch({
      type: 'close'
    });
  }, [dispatch]);
  function open(data, schema, matchFieldsNode, matchFieldsApi) {
    const extraInfo = (data === null || data === void 0 ? void 0 : data.extraInfo) || {};
    const fields = Object.keys(extraInfo);
    const tableSchema = (schema === null || schema === void 0 ? void 0 : schema.tableSchema) || {};
    const canCreate = tableSchema && tableSchema[data.nameField] && tableSchema[data.nameField].extraInfo ? tableSchema[data.nameField].extraInfo.canCreate : false;
    dispatch({
      type: 'init',
      data,
      fields,
      fieldSchema: tableSchema[data.nameField],
      canCreate,
      matchFieldsNode,
      matchFieldsApi
    });
  }

  // Child method
  useEffect(() => {
    onRef && onRef({
      open
    });
  }, [onRef, dispatch]);
  const onMatch = useCallback((field, value) => {
    const finalValue = value || value === 0 ? value : -1;
    dispatch({
      type: 'match',
      field,
      value: finalValue
    });
  }, []);
  const onToggleHideMatchedFlields = useCallback(() => {
    dispatch({
      type: 'toggleHideMatchedFlields'
    });
  }, []);
  const preComponent = useMemo(() => {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Text, null, t('cfm_label_match_fields_values_list_desc')), /*#__PURE__*/React.createElement("div", {
      className: classes.checkboxContainer
    }, /*#__PURE__*/React.createElement(Checkbox, {
      className: classes.checkbox,
      onChange: onToggleHideMatchedFlields,
      checked: state.hideMatchedFlields,
      color: "actionMajor"
    }), /*#__PURE__*/React.createElement(Text, null, t('cfm_label_match_fields_see_unmatched_values'))));
  }, [classes.checkbox, classes.checkboxContainer, onToggleHideMatchedFlields, state.hideMatchedFlields, t]);
  return /*#__PURE__*/React.createElement(Modal, {
    title: t('cfm_title_match_fields_values_list', [state.data ? state.data.name : null]),
    size: "large",
    isOpen: state.isOpen,
    onRequestClose: handleOnClose,
    onConfirm: onConfirmModal,
    onCancel: handleOnClose,
    confirmText: t('cfm_action_save'),
    cancelText: t('cfm_action_cancel'),
    className: classes.root,
    preComponent: preComponent,
    classes: {
      content: classes.content
    }
  }, ((_state$fieldSchema = state.fieldSchema) === null || _state$fieldSchema === void 0 ? void 0 : _state$fieldSchema.extraInfo) && /*#__PURE__*/React.createElement(MatchingList, {
    data: state.data,
    fields: state.fields,
    fieldTable: state.fieldSchema.extraInfo.table,
    onMatch: onMatch,
    canCreate: state.canCreate,
    hideMatchedFlields: state.hideMatchedFlields,
    matchBy: matchBy
  }));
};
process.env.NODE_ENV !== "production" ? MatchingModal.propTypes = {
  onRef: PropTypes.func
} : void 0;
export default /*#__PURE__*/memo(MatchingModal);